import { render, staticRenderFns } from "./ModalTransfer.vue?vue&type=template&id=1eb60770&"
import script from "./ModalTransfer.vue?vue&type=script&lang=js&"
export * from "./ModalTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ModalTransfer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports